export const meetupDate = '2025-11-04';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2025-amsterdam';
export const logoUrl =
  'https://andersenlab.com/?utm_source=sovereignty_amsterdam_2025&utm_medium=event';

export const initialCoordinates = {
  lat: 52.379635941113186,
  lng: 4.922375566461339,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: Digital Sovereignty or Dependence?',
  address: 'Hotel Jakarta Javakade 766\n 1019 SH Amsterdam The Netherlands',
  link: 'https://www.google.com/maps/place/Hotel+Jakarta/@52.3808038,4.9246498,15.75z/data=!4m9!3m8!1s0x47c609077fc05fc1:0xc3f7a0bfe4661563!5m2!4m1!1i2!8m2!3d52.3793871!4d4.9224614!16s%2Fg%2F11dxkt02pq?entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D',
};
